import React, { useMemo } from "react";

import styles from "./CoverImage.scss";
import { getBackgroundImageSrc } from "../../../../services/asset";
import { IndexCarousel } from "../../../../components";
import { Icon } from 'antd';

export interface ICoverImage {
  ad: any;
}

const carouselSettings = {
  autoplay: false,
  arrows: true,
  dots: false,
  fade: true,
  infinite: true,
  lazyLoad: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: true,
  nextArrow: <Icon type="right" />,
  prevArrow: <Icon type="left" />
};

const CoverImage = (props: ICoverImage) => {
  const { ad } = props;

  const hasCoverImage = useMemo(() => {
    return (ad.images && ad.images.length > 0) || (ad.videoUrl && ad.videoUrl.length > 0);
  }, [ad]);

  return (
    <span
      className={`image ${styles.image}`}
      style={
        hasCoverImage ? null : getBackgroundImageSrc()
      }
    >
      {hasCoverImage ? (
        <IndexCarousel
          images={ad.images}
          settings={carouselSettings}
          videoUrl={ad.videoUrl}
          imageClassName={styles.carouselImageClassName}
        />
      ) : null}
    </span>
  );
};

export default CoverImage;



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/CoverImage/CoverImage.tsx